import React from 'react';
import PropTypes from 'prop-types';

import Input from './Input';
import Label from '../Form/Label';
import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';

class CodeInput extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
  }

  static defaultProps = {
    errors: [],
  }

  state = {
    focus: 0,
    code: '',
    errors: this.props.errors, // eslint-disable-line react/destructuring-assignment
    processing: false,
  }

  inputRefs = []

  mounted = false

  formInputName = 'Code Input'

  componentDidMount() {
    this.mounted = true;
    this.focusInput();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  focusInput = () => {
    const { focus } = this.state;
    const input = this.inputRefs[focus];
    if (input) input.focus();
  }

  submitForm = () => {
    this.btnRef.click(); // this is to trick VWO to record form submits
    this.handleSubmit();
  }

  getDigitsFromString = (str) => str.replace(/[^0-9\\.]+/g, '');

  handleChange = (obj) => {
    const sanitizedCode = this.getDigitsFromString(obj[this.formInputName]);

    this.setState((state) => ({
      ...state,
      errors: [],
      code: sanitizedCode,
    }), () => {
      if (sanitizedCode.length === 6) {
        this.submitForm();
        this.setState({ processing: true });
      }
    });
  }

  handlePaste = (e) => {
    const data = e.clipboardData.getData('Text');

    if (!data) {
      return;
    }

    const sanitizedCode = this.getDigitsFromString(data);

    this.setState((state) => ({
      ...state,
      errors: [],
      code: sanitizedCode,
    }), () => {
      if (sanitizedCode.length === 6) {
        this.submitForm();
        this.setState({ processing: true });
      }
    });
  }

  handleSubmit = async () => {
    const { code, processing } = this.state;
    const { onSubmit } = this.props;

    if (processing) return;

    try {
      await onSubmit(code);
      if (!this.mounted) return;

      this.setState({
        errors: [],
        processing: false,
      });
    } catch (err) {
      this.setState({
        errors: [this.formInputName],
        processing: false,
      });
    }
  }

  render() {
    const { errors, code } = this.state;

    return (
      <form
        name="code_input_form"
        onSubmit={(e) => { e.preventDefault(); }}
      >
        <div className="CodeInput">
          <Label forInput={this.formInputName} required>
            <TranslationProvider translationKey="confirmation_code">
              CONFIRMATION CODE
            </TranslationProvider>
          </Label>
          <Input
            name={this.formInputName}
            type="tel"
            onChange={this.handleChange}
            maxlength="6"
            value={code}
            onPaste={this.handlePaste}
            errors={errors}
            placeholder="_ _ _ _ _ _"
            ariaDescribedby="code_input_error"
            ariaInvalid={errors.length > 0}
            ariaLive="polite"
          />
        </div>
        {errors.length > 0 && (
          <TranslationProvider translationKey="code_input_error">
            <p id="code_input_error" className="CodeInput__ErrorMsg" aria-live="assertive">
              Oops, that didn’t work. Please enter the code that was sent to you.
            </p>
          </TranslationProvider>
        )}
        <button
          aria-label={getTranslation({ translationKey: 'button_submit', fallback: 'submit' })}
          ref={(node) => { this.btnRef = node; }}
          className="Button Button--hidden"
          type="submit"
          style={{ display: 'none' }}
        />
      </form>
    );
  }
}

CodeInput.displayName = 'CodeInput';

export default CodeInput;
